module.exports = __webpack_public_path__ + "img/bighome.4b5edbff.png";